import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import Admin from "@/pages/Admin";
import Privacy from "@/pages/Privacy";
import Cookie from "@/pages/Cookie";
import Community from "@/pages/Community";
import { ConsentProvider } from "@/context/ConsentContext";
import { CookieBanner } from "@/components/CookieBanner";

function App() {
  return (
    <ReactLenis root options={{ lerp: 0.08, smoothWheel: true }}>
      <div className="App relative min-h-screen bg-warm text-navy overflow-x-hidden">
        <div className="aurora" aria-hidden />
        <Toaster theme="light" position="top-center" richColors />
        <BrowserRouter>
          <ConsentProvider>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/cookie" element={<Cookie />} />
              <Route path="/community" element={<Community />} />
            </Routes>
            <CookieBanner />
          </ConsentProvider>
        </BrowserRouter>
      </div>
    </ReactLenis>
  );
}

export default App;
